@if (snackbarRef) {
  <app-grid>
    <app-cell mobile="0:12">
      @if (snackbarRef.content) {
        <ng-container [ngTemplateOutlet]="regular"></ng-container>
      }
    </app-cell>
  </app-grid>
}

<ng-template #regular>
  <div class="snackbar">
    <div class="content">
      <p>{{ snackbarRef.content | translate }}</p>
    </div>

    @if (! snackbarRef.autoHideDelay && snackbarRef.dismissible) {
      <app-button
        theme="dark"
        layout="label-only"
        (clicked)="close()"
        >
        {{ 'common.dismiss' | translate }}
      </app-button>
    }
  </div>
</ng-template>
